import React, { useState } from 'react'
import { Box, Container, Grid, Theme, useMediaQuery } from '@mui/material'
import { makeStyles } from '@mui/styles'
import ReactPlayer from 'react-player/lazy'
import PlayArrowIcon from '@mui/icons-material/PlayArrow'
import { img as imgs, img } from '../../../imgs'
import { video } from '../../../video'
import { Modal } from '../../../components'

const items = [
  {
    src: 'https://cup.irb.rest/backend/static/news/gala/all.mp4',
    type: 'video/mp4',
  },
  {
    src: 'https://cup.irb.rest/backend/static/news/gala/all.webm',
    type: 'video/webm',
  },
]

const ReportModal: React.FC<{ className: any; show: boolean; close: () => void }> = ({
  className,
  show = false,
  close = () => {},
}): JSX.Element => {
  const { REACT_APP_DEBUG: DEBUG } = process.env

  const sm = useMediaQuery(({ breakpoints: { down } }: Theme) => down(600))

  return (
    <Modal maxWidth={sm ? 'sm' : 'md'} open={show} onClose={close}>
      <Box className={className.videoBox}>
        <video autoPlay controls width="100%" crossOrigin={DEBUG ? undefined : 'anonymous'}>
          {items.map((k: any, i: number) => (
            <source key={`source-${i}`} src={`${k.src}`} type={`${k.type}`} />
          ))}
        </video>
        {/* <ReactPlayer */}
        {/*  playing */}
        {/*  controls */}
        {/*  width="100%" */}
        {/*  height="100%" */}
        {/*  volume={0.5} */}
        {/*  url={video.src_video} */}
        {/*  config={{ */}
        {/*    file: { */}
        {/*      attributes: { */}
        {/*        controlsList: 'noplaybackrate nodownload', */}
        {/*        disablepictureinpicture: 'true', */}
        {/*      }, */}
        {/*    }, */}
        {/*  }} */}
        {/* /> */}
      </Box>
    </Modal>
  )
}

export const ReportCupSection: React.FC = (): JSX.Element => {
  const classes = useStyles()

  const [videoModal, setVideoModal] = useState<boolean>(false)

  return (
    <Box className={classes.page}>
      <ReportModal className={classes} show={videoModal} close={() => setVideoModal(false)} />

      <Container className={classes.container}>
        <Grid container direction="row" justifyContent="space-between" alignItems="center" spacing={1}>
          <Grid item xs={12} md={4}>
            <Box className={classes.title}>PRO КУБОК</Box>
            <Box className={classes.text}>
              <Box mb={2}>
                <span style={{ fontWeight: 700 }}>PRO КУБОК</span> – теперь здесь видеоистория самого яркого мероприятия
                уходящего года, о восхождении первых Легенд Интернэшнл Ресторант Брэндс, о бескомпромиссной борьбе за
                главную награду, яркие краски праздника и церемонии награждения победителей, кадры лучших роликов
                Видеоконтеста и тепло сердец, бившихся в едином ритме на протяжении всего пути КУБКА IRB в 2023!
              </Box>
            </Box>
          </Grid>
          <Grid item xs={12} md={7}>
            <Box className={classes.vZoom} onClick={() => setVideoModal(true)}>
              <Box id="play-container" className={classes.vVideo} />
              <Box position="absolute" top={0} left={0} className={classes.vPlayBox}>
                <Box id="play-btn" className={classes.vPlay}>
                  <PlayArrowIcon />
                </Box>
              </Box>
            </Box>
          </Grid>
        </Grid>
      </Container>
    </Box>
  )
}

const useStyles = makeStyles(({ breakpoints: { down }, palette }: Theme) => ({
  page: {
    width: '100%',
    padding: '80px 0',
    background: 'linear-gradient(#7D0A13, #1F0103) 0 0 no-repeat',
    [down('md')]: {
      padding: '60px 0',
    },
    [down('sm')]: {
      padding: '30px 0',
    },
  },
  container: {
    maxWidth: '1100px!important',
    [down('lg')]: {
      padding: '0 15px!important',
    },
    [down('md')]: {
      maxWidth: '600px!important',
    },
    [down('sm')]: {
      padding: '0 10px!important',
      maxWidth: '400px!important',
    },
  },
  title: {
    fontSize: 32,
    fontWeight: 700,
    color: palette.text.primary,
    textTransform: 'uppercase',
    margin: '30px 0 20px',
    [down('lg')]: {
      fontSize: 26,
    },
    [down('md')]: {
      fontSize: 24,
      margin: '25px 0 20px',
    },
    [down('sm')]: {
      fontSize: 20,
      textAlign: 'center',
      margin: '20px 0 15px',
    },
  },
  text: {
    fontSize: 18,
    fontWeight: 500,
    [down('lg')]: {
      fontSize: 17,
    },
    [down('md')]: {
      fontSize: 16,
      marginBottom: 30,
    },
    [down('sm')]: {
      fontSize: 13,
      marginBottom: 20,
    },
  },
  vZoom: {
    width: '100%',
    height: 400,
    cursor: 'pointer',
    overflow: 'hidden',
    position: 'relative',
    border: '1px solid #6C6C6C',
    '-webkit-tap-highlight-color': 'transparent',
    background: 'linear-gradient(#7D0A13, #080102) 0 0 no-repeat',
    '&:hover': {
      '& #play-container': {
        transform: 'scale(1.03)',
      },
      '& #play-btn': {
        transform: 'scale(1.03)',
      },
    },
    [down('sm')]: {
      height: '80vw',
      maxHeight: 250,
    },
  },
  vVideo: {
    width: '100%',
    height: 400,
    display: 'flex',
    borderRadius: 6,
    transition: '0.3s',
    alignItems: 'center',
    backgroundSize: '350px 180px',
    justifyContent: 'center',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center',
    backgroundImage: `url(${img.proKubok})`,
    [down('sm')]: {
      height: '80vw',
      maxHeight: 250,
      backgroundSize: '215px 110px',
    },
  },
  vPlayBox: {
    width: '100%',
    height: 400,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    [down('sm')]: {
      height: '80vw',
      maxHeight: 250,
    },
  },
  vPlay: {
    width: 70,
    height: 70,
    borderRadius: '50%',
    display: 'flex',
    transition: '0.2s',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: 'rgba(108, 108, 108, 0.8)',
    backdropFilter: 'blur(10px)',
    '& svg': {
      fill: '#ffffff!important',
      fontSize: '40px!important',
      [down('sm')]: {
        fontSize: '35px!important',
      },
    },
    [down('sm')]: {
      width: 55,
      height: 55,
    },
  },
  videoBox: {
    width: '100%',
    maxWidth: 710,
    margin: '50px auto 25px',
    '& video': {
      borderRadius: 6,
    },
    [down('sm')]: {
      maxWidth: 400,
      margin: '30px auto 5px',
    },
  },
}))
